import React from 'react'

import Form from '../components/Form/Form'

import { formData, sendInfo } from '../data/kddmData'
import { formAnalysis } from '../helpers/analysis'
import Navbar from '../components/Navbar'

const Kddm = () => {
    return (
        <div>
            <Navbar />
            <Form formData={formData} sendInfo={sendInfo} analysis={formAnalysis} />
        </div>
    )
}

export default Kddm


